import React from 'react';
import FlagIconContainer from '../../Componant/Icons/FlagIcon';

const FlagIcon = () => {
  return (
    <div className='page-body'>
      <FlagIconContainer />
    </div>
  );
};

export default FlagIcon;
